import { useQuery } from '@tanstack/react-query';

import { fetchNewlyAddedProducts } from './apiFetchNewlyAddedProducts';
import { Pagination } from '../../../../../models/Pagination';
import { ProductFilter } from '../../../../../models/Product';
import { GlobalReactQueryOptions } from '../../../../config';
import { browserClient } from '../../../../react-query';

const NEWLY_ADDED_PRODUCTS_QUERY = 'newlyAddedProducts';

interface PropTypes {
    ageCategory: string;
    loanFormat: string | null;
    filterMap: ProductFilter;
    pagination: Pagination;
}

export const useNewlyAddedProducts = (props: PropTypes) => {
    const { ageCategory, loanFormat, filterMap, pagination } = props;
    const transformedFilterMap = JSON.stringify(filterMap);

    const { ...data } = useQuery(
        [NEWLY_ADDED_PRODUCTS_QUERY, { ageCategory, loanFormat, filterMap: transformedFilterMap, ...pagination }],
        () => fetchNewlyAddedProducts({ ageCategory, loanFormat, filterMap: transformedFilterMap, pagination }),
        { ...GlobalReactQueryOptions }
    );

    const { data: newlyAddedProducts } = data;
    return {
        ...data,
        products: {
            count: newlyAddedProducts?.totalHits ?? 0,
            list: newlyAddedProducts?.hits ?? []
        }
    };
};

export function invalidateNewlyAddedProducts() {
    return browserClient.invalidateQueries({ queryKey: [NEWLY_ADDED_PRODUCTS_QUERY] });
}
